import * as React from "react"
import { SVGProps } from "react"

const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 25 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M14.9375 7.125C13.1017 8.96081 11.8983 10.1642 10.0625 12L14.9375 16.875"
			strokeWidth="2.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export default ArrowLeft
